import { Component, Inject, OnInit } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { AddProfileDialogComponent } from "../add-profile-dialog/add-profile-dialog.component";
import { DataCatalogueService } from "../../services/data-catalogue.service";
import { ACL } from "../../model/acl";
import { ProfileData } from "../feature-access-rights/feature-access-rights.component";

@Component({
  selector: "app-data-type-access-rights",
  templateUrl: "./data-type-access-rights.component.html",
  styleUrl: "./data-type-access-rights.component.scss",
})
export class DataTypeAccessRightsComponent implements OnInit {
  accessDisplayedColumns: string[] = ["enable", "profileName"];

  aclData: any;
  profilesMap: Record<string, string> = {};
  dataSource: ProfileData[] = [];

  constructor(
    private dialog: MatDialog,
    private catalogueService: DataCatalogueService,
    public dialogRef: MatDialogRef<DataTypeAccessRightsComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      value: string;
      dataType: string;
    },
  ) {}

  ngOnInit(): void {
    this.loadProfiles(() => {
      this.loadACL();
    });
  }

  private loadProfiles(done: () => void): void {
    this.catalogueService
      .getProfiles("2037172d-1390-4033-9017-e5424166927e")
      .subscribe({
        next: (profiles) => {
          this.profilesMap = {};

          profiles.forEach((profile: any) => {
            this.profilesMap[profile.uuid] = profile.name;
          });

          done();
        },
        error: (err) => {
          console.error("Error loading profiles:", err);
          done();
        },
      });
  }

  private loadACL(): void {
    this.catalogueService
      .getEnumACL(
        "2037172d-1390-4033-9017-e5424166927e",
        "aixm",
        this.data.dataType,
        this.data.value,
      )
      .subscribe({
        next: (res) => {
          this.aclData = res;

          this.dataSource = res.map((item: any) => {
            const update = item.update ?? false;

            return {
              profile: this.profilesMap[item.ref] ?? item.ref,
              read: item.read ?? false,
              create: update,
              update,
              decommission: item.decommission ?? false,
              mandatory: item.mandatory ?? false,
              ref: item.ref,
            };
          });
        },
        error: (err) => {
          console.error("Error loading ACL:", err);
        },
      });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    const aclUpdate: ACL = this.dataSource
      .filter((item) => item.ref)
      .map((item) => ({
        ref: item.ref,
        read: item.read,
        create: item.create,
        update: item.update,
        decommission: item.decommission,
        mandatory: item.mandatory,
      }));

    this.catalogueService
      .updateEnumACL(
        "2037172d-1390-4033-9017-e5424166927e",
        "aixm",
        this.data.dataType,
        this.data.value,
        aclUpdate,
      )
      .subscribe({
        next: (res) => {
          console.log("ACL updated:", res);
          this.dialogRef.close(aclUpdate);
        },
        error: (err) => {
          console.error("Error updating ACL:", err);
        },
      });
  }

  toggleRead(element: ProfileData): void {
    element.read = !element.read;

    if (!element.read) {
      element.create = false;
      element.update = false;
      element.decommission = false;
    }
  }

  toggleUpdate(element: ProfileData): void {
    element.update = !element.update;
    element.create = element.update;

    if (element.update) {
      element.read = true;
    }
  }

  toggleDecommission(element: ProfileData): void {
    element.decommission = !element.decommission;

    if (element.decommission) {
      element.read = true;
    }
  }

  openAddProfileDialog(): void {
    const existingProfileRefs = this.dataSource
      .filter((item) => item.ref)
      .map((item) => item.ref);

    const dialogRef = this.dialog.open(AddProfileDialogComponent, {
      width: "400px",
      data: {
        existingProfileRefs,
      },
    });

    dialogRef.afterClosed().subscribe((selectedProfiles: any[]) => {
      if (!selectedProfiles?.length) {
        return;
      }

      selectedProfiles.forEach((profile) => {
        const exists = this.dataSource.some((item) => item.ref === profile.ref);

        if (!exists) {
          this.dataSource.push({
            profile: profile.name,
            ref: profile.ref,
            read: false,
            create: false,
            update: false,
            decommission: false,
            mandatory: false,
          });
        }
      });

      this.dataSource.sort((a, b) => a.profile.localeCompare(b.profile));

      this.dataSource = [...this.dataSource];
    });
  }
}
